export const PortalType = {
  OPS: 'ops',
  BANKS: 'banks',
  ADVISERS: 'advisers',
} as const;

type PortalTypeKey = keyof typeof PortalType;

export type PortalType = typeof PortalType[PortalTypeKey];
